var map = {
	"./accounting-export.svg": [
		"af72",
		"chunk-2d213eb6"
	],
	"./accounts-payable.svg": [
		"9de6",
		"chunk-2d0f0df2"
	],
	"./activity.svg": [
		"af8a",
		"chunk-2d213f04"
	],
	"./add-circle.svg": [
		"6988",
		"chunk-2d0d09f9"
	],
	"./add-emoji.svg": [
		"a621",
		"chunk-2d2089ea"
	],
	"./add-tag.svg": [
		"6c96",
		"chunk-2d0da7c0"
	],
	"./add.svg": [
		"3964",
		"chunk-2d0bac9a"
	],
	"./address-search.svg": [
		"6153",
		"chunk-2d0ceb8f"
	],
	"./adjustment.svg": [
		"1880",
		"chunk-2d0ac055"
	],
	"./agent-accounts.svg": [
		"668e",
		"chunk-2d0cfee3"
	],
	"./alert.svg": [
		"1667",
		"chunk-2d0ab89c"
	],
	"./amazon.svg": [
		"a19d",
		"chunk-2d207831"
	],
	"./app-store.svg": [
		"2d61",
		"chunk-2d0bd9a3"
	],
	"./apple-logo.svg": [
		"c28d",
		"chunk-2d216491"
	],
	"./apply-to-all.svg": [
		"6247",
		"chunk-2d0cef35"
	],
	"./apply-to-selected.svg": [
		"6a80",
		"chunk-2d0da019"
	],
	"./arrow-down.svg": [
		"0217",
		"chunk-2d0a349e"
	],
	"./arrow-right.svg": [
		"9739",
		"chunk-2d0e5efa"
	],
	"./arrow-up.svg": [
		"419a",
		"chunk-2d0c037b"
	],
	"./attachment.svg": [
		"ceca",
		"chunk-2d222936"
	],
	"./auto.svg": [
		"7988",
		"chunk-2d0d7e58"
	],
	"./back.svg": [
		"405c",
		"chunk-2d0bff40"
	],
	"./bank.svg": [
		"d59b",
		"chunk-2d21e450"
	],
	"./batch-picking.svg": [
		"2f12",
		"chunk-2d0be08b"
	],
	"./batch-processing-documents.svg": [
		"5991",
		"chunk-2d0c95b2"
	],
	"./batches.svg": [
		"687e",
		"chunk-2d0d0646"
	],
	"./best-before.svg": [
		"89d9",
		"chunk-2d0df80c"
	],
	"./bold.svg": [
		"dd24",
		"chunk-2d2293b8"
	],
	"./bom-details.svg": [
		"2f18",
		"chunk-2d0be091"
	],
	"./bookmark.svg": [
		"e26e",
		"chunk-2d224d12"
	],
	"./boolean-icon.svg": [
		"3597",
		"chunk-2d0b9df6"
	],
	"./bulk-processing.svg": [
		"439f",
		"chunk-2d0c0b02"
	],
	"./bulletin-board.svg": [
		"cc25",
		"chunk-2d221b99"
	],
	"./burger.svg": [
		"c5fd",
		"chunk-2d217566"
	],
	"./buy.svg": [
		"0a97",
		"chunk-2d0ae605"
	],
	"./calendar.svg": [
		"6439",
		"chunk-2d0cf69a"
	],
	"./cancel.svg": [
		"53e2",
		"chunk-2d0c8481"
	],
	"./canceled.svg": [
		"5fde",
		"chunk-2d0d4408"
	],
	"./carrier.svg": [
		"8684",
		"chunk-2d0de770"
	],
	"./cash-book.svg": [
		"4bb9",
		"chunk-2d0cc03b"
	],
	"./check-circle.svg": [
		"82b7",
		"chunk-2d0ddd85"
	],
	"./check.svg": [
		"23ce",
		"chunk-2d0b2759"
	],
	"./chevron-down.svg": [
		"5081",
		"chunk-2d0c73ca"
	],
	"./chevron-left-double.svg": [
		"186d",
		"chunk-2d0ac04b"
	],
	"./chevron-left.svg": [
		"1fb5",
		"chunk-2d0b721e"
	],
	"./chevron-right-double.svg": [
		"ce8c",
		"chunk-2d222403"
	],
	"./chevron-right.svg": [
		"9e44",
		"chunk-2d0f0bc2"
	],
	"./chevron-up-down.svg": [
		"403c",
		"chunk-2d0bff02"
	],
	"./chevron-up.svg": [
		"8c58",
		"chunk-2d0e9004"
	],
	"./clear.svg": [
		"0416",
		"chunk-2d0a3c1f"
	],
	"./code-error-illustration.svg": [
		"1107",
		"chunk-2d0aa51d"
	],
	"./code-variable.svg": [
		"4690",
		"chunk-2d0c160f"
	],
	"./code.svg": [
		"5442",
		"chunk-2d0c8253"
	],
	"./collective-account.svg": [
		"a9a1",
		"chunk-2d209ade"
	],
	"./collective-debitors.svg": [
		"22b6",
		"chunk-2d0b234a"
	],
	"./column-options.svg": [
		"f568",
		"chunk-2d22cc87"
	],
	"./columns.svg": [
		"70fd",
		"chunk-2d0d624d"
	],
	"./comment.svg": [
		"3ca30",
		"chunk-747d9fb8"
	],
	"./commission-warehouse.svg": [
		"e5dd",
		"chunk-2d225de6"
	],
	"./commission.svg": [
		"6fa7",
		"chunk-2d0db7dc"
	],
	"./company-settings.svg": [
		"4b619",
		"chunk-748aa13a"
	],
	"./connected-data.svg": [
		"c0e9",
		"chunk-2d216257"
	],
	"./console.svg": [
		"63e7",
		"chunk-2d0cf8e5"
	],
	"./contacts.svg": [
		"cbac",
		"chunk-2d221db7"
	],
	"./copy.svg": [
		"3137",
		"chunk-2d0b8e38"
	],
	"./credit-notes.svg": [
		"497a",
		"chunk-2d0c2145"
	],
	"./csv.svg": [
		"6b87",
		"chunk-2d0da3e1"
	],
	"./currency.svg": [
		"5989",
		"chunk-2d0c959b"
	],
	"./datev.svg": [
		"00c3",
		"chunk-2d0a3326"
	],
	"./decrease.svg": [
		"1b4a",
		"chunk-2d0b5db4"
	],
	"./delete.svg": [
		"c553",
		"chunk-2d216f46"
	],
	"./delivery-dates.svg": [
		"4f60",
		"chunk-2d0cc9e2"
	],
	"./delivery-note.svg": [
		"7ae0",
		"chunk-2d0e19eb"
	],
	"./delivery-notes.svg": [
		"fa8f",
		"chunk-2d23721f"
	],
	"./details.svg": [
		"0749",
		"chunk-2d0a47c2"
	],
	"./dhl.svg": [
		"7731",
		"chunk-2d0d7634"
	],
	"./discounts.svg": [
		"185f",
		"chunk-2d0ac02e"
	],
	"./dispatch-center.svg": [
		"18b0",
		"chunk-2d0ac56b"
	],
	"./divider-icon.svg": [
		"6bf8",
		"chunk-2d0da974"
	],
	"./document-batch-processing.svg": [
		"a47f",
		"chunk-2d208338"
	],
	"./document-scanner.svg": [
		"45cf",
		"chunk-2d0c179a"
	],
	"./download.svg": [
		"af61",
		"chunk-2d213e96"
	],
	"./drag-icon.svg": [
		"a781",
		"chunk-2d208e65"
	],
	"./dropshipping-warehouse.svg": [
		"c979",
		"chunk-2d217e8e"
	],
	"./dunning.svg": [
		"ef48",
		"chunk-2d230fdb"
	],
	"./ean-generator.svg": [
		"6a1a",
		"chunk-2d0d9f71"
	],
	"./edit-all.svg": [
		"0f72",
		"chunk-2d0af887"
	],
	"./edit.svg": [
		"cea0",
		"chunk-2d2228c7"
	],
	"./email-archive.svg": [
		"ae8b",
		"chunk-2d213b44"
	],
	"./email.svg": [
		"d2f3",
		"chunk-2d21de51"
	],
	"./employee-time-tracking.svg": [
		"fe0f",
		"chunk-2d23802b"
	],
	"./employees.svg": [
		"8a01",
		"chunk-2d0e87e0"
	],
	"./empty-table.svg": [
		"6d6e",
		"chunk-2d0dab53"
	],
	"./empty.svg": [
		"bddf",
		"chunk-2d21b13a"
	],
	"./enter.svg": [
		"3f82",
		"chunk-2d0c55c3"
	],
	"./excel.svg": [
		"a6b4",
		"chunk-2d208fbd"
	],
	"./experimental.svg": [
		"6274",
		"chunk-2d0cef8f"
	],
	"./external-link.svg": [
		"7328",
		"chunk-2d0d6718"
	],
	"./external-product-numbers.svg": [
		"e6aa",
		"chunk-2d226147"
	],
	"./favourite.svg": [
		"d760",
		"chunk-2d21eb43"
	],
	"./fax.svg": [
		"7f0c",
		"chunk-2d0e2678"
	],
	"./feedback.svg": [
		"4516",
		"chunk-2d0c115c"
	],
	"./file.svg": [
		"a499",
		"chunk-2d208349"
	],
	"./filter.svg": [
		"beae",
		"chunk-2d21b49d"
	],
	"./filters.svg": [
		"ba5c",
		"chunk-2d21a043"
	],
	"./finance.svg": [
		"8ebf",
		"chunk-2d0e9d27"
	],
	"./financial-account-export.svg": [
		"f46d",
		"chunk-2d22c8f2"
	],
	"./flag-de.svg": [
		"bd9d",
		"chunk-2d21ac03"
	],
	"./flag-uk.svg": [
		"3ca4",
		"chunk-2d0c4f79"
	],
	"./folder-plus.svg": [
		"9b36",
		"chunk-2d0f0062"
	],
	"./follow-up.svg": [
		"5447",
		"chunk-2d0c8258"
	],
	"./framework-agreement.svg": [
		"8183",
		"chunk-2d0dd4aa"
	],
	"./free-products.svg": [
		"9d1e",
		"chunk-2d0f07d5"
	],
	"./gmail.svg": [
		"81ca",
		"chunk-2d0dda0d"
	],
	"./good-receipt.svg": [
		"1ced",
		"chunk-2d0b6767"
	],
	"./goods-posting-document.svg": [
		"40ce",
		"chunk-2d0c04d4"
	],
	"./goods-receipt-documents.svg": [
		"f1c8",
		"chunk-2d22c2f6"
	],
	"./google.svg": [
		"f34e",
		"chunk-2d22c4f4"
	],
	"./group-invoice.svg": [
		"9893",
		"chunk-2d0e636f"
	],
	"./hash.svg": [
		"aa4d",
		"chunk-2d212bc6"
	],
	"./help.svg": [
		"11cc",
		"chunk-2d0aab76"
	],
	"./hide.svg": [
		"da15",
		"chunk-2d228857"
	],
	"./home.svg": [
		"b85a",
		"chunk-2d210658"
	],
	"./illustration-missing-data.svg": [
		"2ceb",
		"chunk-2d0bdbc4"
	],
	"./illustration-questions.svg": [
		"4a60",
		"chunk-2d0cb71d"
	],
	"./image.svg": [
		"024c",
		"chunk-2d0a3527"
	],
	"./import-export.svg": [
		"b60c",
		"chunk-2d20fe3d"
	],
	"./in-progress.svg": [
		"6c09",
		"chunk-2d0da6ac"
	],
	"./inbox.svg": [
		"424f",
		"chunk-2d0c06a6"
	],
	"./incoming-payments.svg": [
		"9e5a",
		"chunk-2d0f0c0e"
	],
	"./increase.svg": [
		"5537",
		"chunk-2d0c85fa"
	],
	"./indeterminate.svg": [
		"21ff",
		"chunk-2d0b2035"
	],
	"./info.svg": [
		"2f7a",
		"chunk-2d0be174"
	],
	"./inquiry.svg": [
		"7ebe",
		"chunk-2d0e28c7"
	],
	"./interfaces.svg": [
		"82fb",
		"chunk-2d0dde2c"
	],
	"./interim-storage.svg": [
		"69aa",
		"chunk-2d0d0f19"
	],
	"./internet.svg": [
		"ee95",
		"chunk-2d230cb2"
	],
	"./inventory-icon.svg": [
		"6f94",
		"chunk-2d0db301"
	],
	"./inventory-mobile.svg": [
		"4532",
		"chunk-2d0c1196"
	],
	"./inventory-performance-dashboard.svg": [
		"9585",
		"chunk-2d0e580f"
	],
	"./inventory.svg": [
		"984b",
		"chunk-2d0e6303"
	],
	"./invoice-run.svg": [
		"016d",
		"chunk-2d0a31a5"
	],
	"./invoices.svg": [
		"5da2",
		"chunk-2d0d3bf6"
	],
	"./italic.svg": [
		"949e",
		"chunk-2d0e549d"
	],
	"./key.svg": [
		"dd64",
		"chunk-2d229434"
	],
	"./launchpad.svg": [
		"633d",
		"chunk-2d0cf304"
	],
	"./license.svg": [
		"d97d",
		"chunk-2d21f318"
	],
	"./link.svg": [
		"61b9",
		"chunk-2d0cf108"
	],
	"./liquidity.svg": [
		"3183",
		"chunk-2d0b8ecf"
	],
	"./lock-selection.svg": [
		"48c8",
		"chunk-2d0c22af"
	],
	"./lock.svg": [
		"98f1",
		"chunk-2d0e68e0"
	],
	"./logo_extended.svg": [
		"26bd",
		"chunk-2d0b327c"
	],
	"./logo_small.svg": [
		"832b",
		"chunk-2d0ddba1"
	],
	"./logout.svg": [
		"5089",
		"chunk-2d0c73d2"
	],
	"./management-board.svg": [
		"f1ce",
		"chunk-2d22c323"
	],
	"./management.svg": [
		"f7a0",
		"chunk-2d22d936"
	],
	"./matrix-product.svg": [
		"5118",
		"chunk-2d0c76b9"
	],
	"./maximize.svg": [
		"d156",
		"chunk-2d21d4a4"
	],
	"./merge-orders.svg": [
		"cf7a",
		"chunk-2d2227a3"
	],
	"./microsoft.svg": [
		"62f7",
		"chunk-2d0cf543"
	],
	"./minimize.svg": [
		"6999",
		"chunk-2d0d0a19"
	],
	"./minus.svg": [
		"5519",
		"chunk-2d0c85be"
	],
	"./mobile-phone.svg": [
		"69cd",
		"chunk-2d0d0f5a"
	],
	"./mobile-picking-profile.svg": [
		"e8ff",
		"chunk-2d226969"
	],
	"./mobile-replenishment.svg": [
		"24f3",
		"chunk-2d0b2b45"
	],
	"./mobile-warehouse.svg": [
		"d744",
		"chunk-2d21eb09"
	],
	"./monitor.svg": [
		"3216",
		"chunk-2d0b91ba"
	],
	"./more.svg": [
		"5dc8",
		"chunk-2d0d3c3a"
	],
	"./navigate.svg": [
		"2054",
		"chunk-2d0b1653"
	],
	"./next.svg": [
		"7106",
		"chunk-2d0d5f56"
	],
	"./no-data.svg": [
		"6287",
		"chunk-2d0cefb1"
	],
	"./not-found-whoops.svg": [
		"f4da8",
		"chunk-773701d7"
	],
	"./not-found.svg": [
		"40023",
		"chunk-7473d03f"
	],
	"./offers.svg": [
		"1012",
		"chunk-2d0aa176"
	],
	"./office-365.svg": [
		"266e",
		"chunk-2d0b2d29"
	],
	"./open.svg": [
		"f0b3",
		"chunk-2d22bf11"
	],
	"./order-open-positions.svg": [
		"5fdef",
		"chunk-749b3d5e"
	],
	"./order-proposal.svg": [
		"1518",
		"chunk-2d0ab441"
	],
	"./ordered-list.svg": [
		"1f47",
		"chunk-2d0b6c8e"
	],
	"./outlook.svg": [
		"6654",
		"chunk-2d0cfe55"
	],
	"./overview-dashboard.svg": [
		"7044",
		"chunk-2d0d5c0f"
	],
	"./overview.svg": [
		"9e90",
		"chunk-2d0f0c59"
	],
	"./package-receipt.svg": [
		"f9b6",
		"chunk-2d22e0dd"
	],
	"./paste.svg": [
		"93ca",
		"chunk-2d0e55ee"
	],
	"./pause.svg": [
		"dec6",
		"chunk-2d229d6a"
	],
	"./payments.svg": [
		"ad4a",
		"chunk-2d213706"
	],
	"./payout.svg": [
		"7913",
		"chunk-2d0d7d7a"
	],
	"./payroll.svg": [
		"8f3b",
		"chunk-2d0e9b33"
	],
	"./pdf.svg": [
		"38ac",
		"chunk-2d0bae3d"
	],
	"./phone-call.svg": [
		"5da3",
		"chunk-2d0d3bf7"
	],
	"./picking-process.svg": [
		"e382",
		"chunk-2d2250de"
	],
	"./picking-run.svg": [
		"3cb3",
		"chunk-2d0c4f97"
	],
	"./picking.svg": [
		"c019",
		"chunk-2d215c0b"
	],
	"./pin.svg": [
		"3410e",
		"chunk-74678def"
	],
	"./placeholder-icon.svg": [
		"1039",
		"chunk-2d0aa1bb"
	],
	"./placeholder-illustration.svg": [
		"a4e1",
		"chunk-2d208895"
	],
	"./placeholder-tile-icon.svg": [
		"4192",
		"chunk-2d0c034c"
	],
	"./play.svg": [
		"6bddf",
		"chunk-74a78344"
	],
	"./preview.svg": [
		"a2cf",
		"chunk-2d20810a"
	],
	"./price-request.svg": [
		"79ff",
		"chunk-2d0d8418"
	],
	"./print.svg": [
		"232e",
		"chunk-2d0b216a"
	],
	"./pro-forma-invoice.svg": [
		"9ccb",
		"chunk-2d0f0a1f"
	],
	"./product-categories.svg": [
		"2b22b",
		"chunk-746e637c"
	],
	"./product-properties.svg": [
		"d851",
		"chunk-2d21eee6"
	],
	"./product-tree.svg": [
		"aafa",
		"chunk-2d2131d1"
	],
	"./product-units.svg": [
		"cc78",
		"chunk-2d221c37"
	],
	"./product.svg": [
		"2e70",
		"chunk-2d0bdd82"
	],
	"./production.svg": [
		"6863",
		"chunk-2d0d05f5"
	],
	"./products.svg": [
		"fdf3",
		"chunk-2d2382c1"
	],
	"./project.svg": [
		"690b",
		"chunk-2d0d092b"
	],
	"./properties-template.svg": [
		"0475",
		"chunk-2d0a3cd8"
	],
	"./purchase-order-proposals.svg": [
		"b8ff",
		"chunk-2d210c4c"
	],
	"./purchase-order.svg": [
		"a881",
		"chunk-2d209226"
	],
	"./purchase-suggestions.svg": [
		"75c4",
		"chunk-2d0d7485"
	],
	"./quotes.svg": [
		"f0cc",
		"chunk-2d22bf60"
	],
	"./redo.svg": [
		"810c",
		"chunk-2d0dd3e2"
	],
	"./released.svg": [
		"1a10",
		"chunk-2d0b5965"
	],
	"./remove-formatting.svg": [
		"9144",
		"chunk-2d0e488e"
	],
	"./reports.svg": [
		"15bc",
		"chunk-2d0aba5b"
	],
	"./returns-reason.svg": [
		"1c9c",
		"chunk-2d0b6212"
	],
	"./returns.svg": [
		"62a2",
		"chunk-2d0cf4a3"
	],
	"./revenue-analyzer.svg": [
		"2ede",
		"chunk-2d0be32a"
	],
	"./rows.svg": [
		"15a7",
		"chunk-2d0aba10"
	],
	"./sage-accounting-export.svg": [
		"c3c3",
		"chunk-2d216d56"
	],
	"./sales-figures.svg": [
		"176f0",
		"chunk-744cd524"
	],
	"./sales-order-status.svg": [
		"8281",
		"chunk-2d0dd869"
	],
	"./sales-order-to-purchase-order.svg": [
		"d4cd",
		"chunk-2d21e5a7"
	],
	"./sales-orders-multi.svg": [
		"47cb",
		"chunk-2d0c1f18"
	],
	"./sales-orders.svg": [
		"6628",
		"chunk-2d0cfdfc"
	],
	"./sales-statistics.svg": [
		"f768",
		"chunk-2d22d409"
	],
	"./scan.svg": [
		"8030",
		"chunk-2d0dd04b"
	],
	"./scanning-slips.svg": [
		"855e",
		"chunk-2d0de383"
	],
	"./search-in-content.svg": [
		"d80f",
		"chunk-2d21ee80"
	],
	"./search.svg": [
		"5af3",
		"chunk-2d0d314f"
	],
	"./season.svg": [
		"82c4",
		"chunk-2d0ddda1"
	],
	"./sell.svg": [
		"0ab7",
		"chunk-2d0aeafc"
	],
	"./serial-numbers.svg": [
		"cf6c",
		"chunk-2d222786"
	],
	"./service-order-scan.svg": [
		"9007",
		"chunk-2d0e4454"
	],
	"./service-order.svg": [
		"3118",
		"chunk-2d0b8dfb"
	],
	"./service-partner.svg": [
		"c137",
		"chunk-2d216008"
	],
	"./set-up.svg": [
		"25aa",
		"chunk-2d0b2e99"
	],
	"./sets-bundle.svg": [
		"a191",
		"chunk-2d2077fe"
	],
	"./share.svg": [
		"8bda",
		"chunk-2d0e921d"
	],
	"./shipping-tax-split.svg": [
		"5f0f",
		"chunk-2d0d3dbd"
	],
	"./shopify.svg": [
		"f075",
		"chunk-2d22b9de"
	],
	"./shops-and-marketplaces.svg": [
		"ec2f",
		"chunk-2d230488"
	],
	"./shopware.svg": [
		"1a99",
		"chunk-2d0b5a66"
	],
	"./show.svg": [
		"e9c2",
		"chunk-2d226c99"
	],
	"./simple-wage-payment.svg": [
		"eadf",
		"chunk-2d230314"
	],
	"./slack-notification.svg": [
		"2b9e",
		"chunk-2d0bd2b2"
	],
	"./sort-asc.svg": [
		"0b4f",
		"chunk-2d0ae95a"
	],
	"./sort-desc.svg": [
		"f2c8",
		"chunk-2d22c6b7"
	],
	"./sort.svg": [
		"3a00",
		"chunk-2d0c4204"
	],
	"./spinner.svg": [
		"5209",
		"chunk-2d0c7a5c"
	],
	"./statistics.svg": [
		"1809",
		"chunk-2d0abf66"
	],
	"./stock-in-out.svg": [
		"8c60",
		"chunk-2d0e901b"
	],
	"./stock.svg": [
		"ee36",
		"chunk-2d230bf9"
	],
	"./stop.svg": [
		"afda",
		"chunk-2d214458"
	],
	"./storage.svg": [
		"95b3",
		"chunk-2d0e5d23"
	],
	"./store-and-retrieve-orders.svg": [
		"928f",
		"chunk-2d0e4cfd"
	],
	"./store-order.svg": [
		"d286",
		"chunk-2d21d8c2"
	],
	"./store-receipts.svg": [
		"0896",
		"chunk-2d0a4c1b"
	],
	"./subscription.svg": [
		"e126",
		"chunk-2d2248a6"
	],
	"./suppliers.svg": [
		"1af3",
		"chunk-2d0b5fd3"
	],
	"./system-messages.svg": [
		"47c7",
		"chunk-2d0c1eed"
	],
	"./system-settings.svg": [
		"2aeb",
		"chunk-2d0bd442"
	],
	"./table.svg": [
		"ce83",
		"chunk-2d2223d3"
	],
	"./tasks.svg": [
		"6157",
		"chunk-2d0ceb93"
	],
	"./tax-rate-high.svg": [
		"1925",
		"chunk-2d0ac361"
	],
	"./tax-rate-low.svg": [
		"c1c5",
		"chunk-2d2165d6"
	],
	"./taxes.svg": [
		"9782",
		"chunk-2d0e5f8e"
	],
	"./team-management.svg": [
		"83f8",
		"chunk-2d0de1c3"
	],
	"./templates.svg": [
		"cac0",
		"chunk-2d221a01"
	],
	"./text-color.svg": [
		"c679",
		"chunk-2d21734b"
	],
	"./text.svg": [
		"7b66",
		"chunk-2d0e1801"
	],
	"./tick.svg": [
		"7d43",
		"chunk-2d0e1f42"
	],
	"./time-clock.svg": [
		"f398",
		"chunk-2d22c562"
	],
	"./time-tracking-costs.svg": [
		"6ccc",
		"chunk-2d0dad03"
	],
	"./time-tracking.svg": [
		"4c00",
		"chunk-2d0cbde5"
	],
	"./totes.svg": [
		"c376",
		"chunk-2d216805"
	],
	"./tracking-scan.svg": [
		"81d8",
		"chunk-2d0dda03"
	],
	"./tracking.svg": [
		"83d7",
		"chunk-2d0de184"
	],
	"./transfer.svg": [
		"cbcf",
		"chunk-2d221df8"
	],
	"./trash.svg": [
		"a9ed",
		"chunk-2d209b8d"
	],
	"./type-icon.svg": [
		"3a2c",
		"chunk-2d0c4275"
	],
	"./underline.svg": [
		"bb9d",
		"chunk-2d21a481"
	],
	"./undo.svg": [
		"87ef",
		"chunk-2d0df0d6"
	],
	"./unlink.svg": [
		"5760",
		"chunk-2d0c8dd2"
	],
	"./unordered-list.svg": [
		"db50",
		"chunk-2d228c8f"
	],
	"./unpin.svg": [
		"a088",
		"chunk-2d207425"
	],
	"./updates.svg": [
		"ba93",
		"chunk-2d21a08f"
	],
	"./upload-to-cloud.svg": [
		"8155",
		"chunk-2d0dd44f"
	],
	"./upload.svg": [
		"fad1",
		"chunk-2d23773e"
	],
	"./ups-account.svg": [
		"ffcc",
		"chunk-2d238a16"
	],
	"./ups.svg": [
		"d29d",
		"chunk-2d21d90f"
	],
	"./voucher.svg": [
		"c19c",
		"chunk-2d2160ee"
	],
	"./warehouse-management.svg": [
		"1914",
		"chunk-2d0ac341"
	],
	"./woocommerce.svg": [
		"17d1",
		"chunk-2d0ac1e9"
	],
	"./workplace-groups.svg": [
		"9414",
		"chunk-2d0e5374"
	],
	"./xentral-done-illustrated.svg": [
		"2b96",
		"chunk-2d0bd283"
	],
	"./xentral-logo-illustrated.svg": [
		"03ee",
		"chunk-2d0a3ed9"
	],
	"./zip.svg": [
		"6f59",
		"chunk-2d0db28a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2269";
module.exports = webpackAsyncContext;